// extracted by mini-css-extract-plugin
module.exports = {"lightGrey":"undefined","container":"TabNav_container__1LOWp"};